import { Action } from '@ngrx/store'
import * as DataCyclesTypes from './data-cycles.types'
import { DataCycle } from './data-cycles.interface'

export class FetchDataCyclesRequest implements Action {
  readonly type = DataCyclesTypes.FETCH_DATA_CYCLES_REQUEST
  constructor(public payload: any = {}) {}
}

export class FetchDataCyclesSuccess implements Action {
  readonly type = DataCyclesTypes.FETCH_DATA_CYCLES_SUCCESS
  constructor(
    public payload: DataCycle[],
    public total: number,
    public results: number,
  ) {}
}

export class FetchDataCyclesFailure implements Action {
  readonly type = DataCyclesTypes.FETCH_DATA_CYCLES_FAILURE
  constructor(public payload: any) {}
}

export class FetchDataCycleRequest implements Action {
  readonly type = DataCyclesTypes.FETCH_DATA_CYCLE_REQUEST
  constructor(public id: number) {}
}

export class FetchDataCycleSuccess implements Action {
  readonly type = DataCyclesTypes.FETCH_DATA_CYCLE_SUCCESS
  constructor(public payload: DataCycle) {}
}

export class FetchDataCycleFailure implements Action {
  readonly type = DataCyclesTypes.FETCH_DATA_CYCLE_FAILURE
  constructor(public payload: any) {}
}

export class DeleteDataCycleRequest implements Action {
  readonly type = DataCyclesTypes.DELETE_DATA_CYCLE_REQUEST
  constructor(public id: number) {}
}

export class DeleteDataCycleSuccess implements Action {
  readonly type = DataCyclesTypes.DELETE_DATA_CYCLE_SUCCESS
  constructor() {}
}

export class DeleteDataCycleFailure implements Action {
  readonly type = DataCyclesTypes.DELETE_DATA_CYCLE_FAILURE
  constructor(public payload: any) {}
}

export class CreateDataCycleRequest implements Action {
  readonly type = DataCyclesTypes.CREATE_DATA_CYCLE_REQUEST
  constructor(public payload) {}
}

export class CreateDataCycleSuccess implements Action {
  readonly type = DataCyclesTypes.CREATE_DATA_CYCLE_SUCCESS
  constructor() {}
}

export class CreateDataCycleFailure implements Action {
  readonly type = DataCyclesTypes.CREATE_DATA_CYCLE_FAILURE
  constructor(public payload: any) {}
}

export class UpdateDataCycleRequest implements Action {
  readonly type = DataCyclesTypes.UPDATE_DATA_CYCLE_REQUEST
  constructor(public id: number, public payload) {}
}

export class UpdateDataCycleSuccess implements Action {
  readonly type = DataCyclesTypes.UPDATE_DATA_CYCLE_SUCCESS
  constructor() {}
}

export class UpdateDataCycleFailure implements Action {
  readonly type = DataCyclesTypes.UPDATE_DATA_CYCLE_FAILURE
  constructor(public payload: any) {}
}

export class UpdateField implements Action {
  readonly type = DataCyclesTypes.UPDATE_FIELD
  public constructor(
    public field: string,
    public value: any,
    public path: string,
  ) {}
}

export class FetchBatchTaskStatusRequest implements Action {
  readonly type = DataCyclesTypes.FETCH_BATCH_TASK_STATUS_REQUEST
  constructor() {}
}

export class FetchBatchTaskStatusSuccess implements Action {
  readonly type = DataCyclesTypes.FETCH_BATCH_TASK_STATUS_SUCCESS
  constructor(public payload: any) {}
}

export class FetchBatchTaskStatusFailure implements Action {
  readonly type = DataCyclesTypes.FETCH_BATCH_TASK_STATUS_FAILURE
  constructor(public payload: any) {}
}

export class SwitchDataCycleRequest implements Action {
  readonly type = DataCyclesTypes.SWITCH_DATA_CYCLE_REQUEST
  constructor(public id: number) {}
}

export class SwitchDataCycleSuccess implements Action {
  readonly type = DataCyclesTypes.SWITCH_DATA_CYCLE_SUCCESS
  constructor(public payload: any) {}
}

export class SwitchDataCycleFailure implements Action {
  readonly type = DataCyclesTypes.SWITCH_DATA_CYCLE_FAILURE
  constructor(public payload: any) {}
}

export class StopDataCycleSwitchingRequest implements Action {
  readonly type = DataCyclesTypes.STOP_DATA_CYCLE_SWITCHING_REQUEST
  constructor(public payload: any = {}) {}
}

export class StopDataCycleSwitchingSuccess implements Action {
  readonly type = DataCyclesTypes.STOP_DATA_CYCLE_SWITCHING_SUCCESS
  constructor(public payload: any) {}
}

export class StopDataCycleSwitchingFailure implements Action {
  readonly type = DataCyclesTypes.STOP_DATA_CYCLE_SWITCHING_FAILURE
  constructor(public payload: any) {}
}

export class FetchDataCycleStatsRequest implements Action {
  readonly type = DataCyclesTypes.FETCH_DATA_CYCLE_STATS_REQUEST
  constructor() {}
}

export class FetchDataCycleStatsSuccess implements Action {
  readonly type = DataCyclesTypes.FETCH_DATA_CYCLE_STATS_SUCCESS
  constructor(public payload: any) {}
}

export class FetchDataCycleStatsFailure implements Action {
  readonly type = DataCyclesTypes.FETCH_DATA_CYCLE_STATS_FAILURE
  constructor(public payload: any) {}
}

export class FetchInitSwitchStatsRequest implements Action {
  readonly type = DataCyclesTypes.FETCH_INIT_SWITCH_STATS_REQUEST
  constructor(public payload: any = {}) {}
}

export class FetchInitSwitchStatsSuccess implements Action {
  readonly type = DataCyclesTypes.FETCH_INIT_SWITCH_STATS_SUCCESS
  constructor(public payload: any) {}
}

export class FetchInitSwitchStatsFailure implements Action {
  readonly type = DataCyclesTypes.FETCH_INIT_SWITCH_STATS_FAILURE
  constructor(public payload: any) {}
}

export class SetDefaultData implements Action {
  readonly type = DataCyclesTypes.SET_DEFAULT_DATA
  public constructor(public path: string) {}
}

export type Actions =
  | UpdateDataCycleRequest
  | UpdateDataCycleSuccess
  | UpdateDataCycleFailure
  | FetchDataCyclesSuccess
  | FetchDataCyclesFailure
  | FetchDataCyclesRequest
  | FetchDataCycleSuccess
  | FetchDataCycleFailure
  | FetchDataCycleRequest
  | CreateDataCycleRequest
  | CreateDataCycleSuccess
  | CreateDataCycleFailure
  | DeleteDataCycleRequest
  | DeleteDataCycleSuccess
  | DeleteDataCycleFailure
  | SetDefaultData
  | UpdateField
  | FetchDataCyclesRequest
  | FetchDataCyclesSuccess
  | FetchDataCyclesFailure
  | FetchBatchTaskStatusRequest
  | FetchBatchTaskStatusSuccess
  | FetchBatchTaskStatusFailure
  | SwitchDataCycleRequest
  | SwitchDataCycleSuccess
  | SwitchDataCycleFailure
  | StopDataCycleSwitchingRequest
  | StopDataCycleSwitchingSuccess
  | StopDataCycleSwitchingFailure
  | FetchDataCycleStatsRequest
  | FetchDataCycleStatsSuccess
  | FetchDataCycleStatsFailure
  | FetchInitSwitchStatsRequest
  | FetchInitSwitchStatsSuccess
  | FetchInitSwitchStatsFailure
